import { equal } from '@ember/object/computed';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
import { OrderTickets as OrderTicketsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/order_tickets';
import Enum from '@square/dashboard-utilities/utils/enum';
export const OrderTicketNamingType = new Enum(Object.keys(OrderTicketsProto.OrderTicketNamingType));
export default ProtoBaseModel.extend({
  namingType: attr(OrderTicketNamingType),
  isAutoTicketNumbering: equal('namingType', OrderTicketNamingType.AUTOMATIC_NUMBERING),
  isManualTicketNumbering: equal('namingType', OrderTicketNamingType.CUSTOM_NAME),
  displayValueTranslationKey: computed('namingType', function () {
    return this.namingType === OrderTicketNamingType.AUTOMATIC_NUMBERING ? 'business.devices.profiles.v2.settings.checkout.orderTickets.namingType.displayValue.auto' : 'business.devices.profiles.v2.settings.checkout.orderTickets.namingType.displayValue.manual';
  })
});